export default __webpack_public_path__ + "static/media/mixkit-fairy-bells-583.004cea7b.mp3";